


// import React, { useEffect, useState } from 'react';
// import '../../style/shop.css';
// import { useNavigate } from 'react-router-dom';
// import { useSelector, useDispatch } from 'react-redux';
// import cart from '../../assets/carttt.png'
// import { removeFromCart, updateQuantity, setCart, setCartId, setTotalPrice } from '../../store/cartSlice';
// import { getWithTokenAPI, postWithTokenAPI, putAPI } from '../../util/Api';
// import { setTotalItems } from '../../store/cartSlice';
// import { toast } from 'react-toastify'; // Import toast for notifications

// const ShoppingCart = ({ apiEndpoint = '/cart/find-all' }) => {
//     const navigate = useNavigate();
//     const dispatch = useDispatch();
//     const accessToken = useSelector((state) => state.auth?.auth?.access_token);
//     const userId = useSelector(state => state.auth?.auth?._id);
//     const userPhoneNumber = useSelector(state => state.auth?.auth?.phone_number); // Get phone number for M-Pesa
//     const cartItems = useSelector((state) => state.cart.cartItems);
//     const totalPrice = useSelector((state) => state.cart.totalPrice);
//     const [couponCode, setCouponCode] = useState('');
//     const [cartSuccessMessage, setCartSuccessMessage] = useState('');
//     const [removingFromCart, setRemovingFromCart] = useState(false);
//     const [error, setError] = useState(null);
//     const [isLoginPopupOpen, setLoginPopupOpen] = useState(false);
//     const [isLoading, setIsLoading] = useState(true);
//     const totals = useSelector((state) => state.cart.totalItems);
//     const cartId = useSelector((state) => state.cart.cartId);
//     const [tax, setTax] = useState(0);

//     // New states for subscription flow, moved from BillingInfo
//     const [showSubscriptionPrompt, setShowSubscriptionPrompt] = useState(false);
//     const [showSubscriptionDetails, setShowSubscriptionDetails] = useState(false);
//     const [subscriptionLoading, setSubscriptionLoading] = useState(false);
//     const [userSubscriptionStatus, setUserSubscriptionStatus] = useState(false); // To store fetched subscription status
// const [subscriptionID, setSubsrcriptionId]= useState(false)
//    const [paymentLoader, setPaymentLoader] = useState(false);
//     const [paymentSuccess, setPaymentSuccess] = useState(false);
//     const [paymentFailed, setPaymentFailed] = useState(false);
//     const [showLoader, setShowLoader] = useState(false);
//     useEffect(() => {
//         const fetchCartAndSubscription = async () => {
//             if (!accessToken) {
//                 setIsLoading(false);
//                 return;
//             }

//             try {
//                 setIsLoading(true);

//                 // Fetch cart data
//                 const cartResponse = await getWithTokenAPI(accessToken, apiEndpoint);
//                 const cartData = cartResponse?.data?.Cart?.[0]; // Ensure safe access
                
//                 if (cartResponse?.statusCode === 200 && cartData) {
//                     setTax(cartData.tax || 0);
//                     if (cartData?.cart?.length) {
//                         const formattedCartItems = cartData.cart.map(item => ({
//                             id: item._id,
//                             productId: item.product_id._id,
//                             image: item.product_id.product_image?.[0] || "",
//                             name: item.product_id.name || "",
//                             price: parseFloat(item.product_id.discount_price || item.product_id.price || 0),
//                             quantity: item.quantity || 1
//                         }));
//                         dispatch(setCart(formattedCartItems));
//                         dispatch(setCartId(cartData._id));
//                         dispatch(setTotalItems(cartData.cart.length));
//                         dispatch(setTotalPrice(cartData.total_Price || 0));
//                     } else {
//                         dispatch(setCart([]));
//                         dispatch(setCartId(null));
//                         dispatch(setTotalItems(0));
//                         dispatch(setTotalPrice(0));
//                     }
//                 } else {
//                     dispatch(setCart([]));
//                     dispatch(setCartId(null));
//                     dispatch(setTotalItems(0));
//                     dispatch(setTotalPrice(0));
//                     setTax(0);
//                 }

//                 // Fetch user subscription status
//                 if (userId) {
//                     const userResponse = await getWithTokenAPI(accessToken, `/user/find-particular?_id=${userId}`);
//                     if (userResponse.statusCode === 200 && userResponse.data) {
//                         setUserSubscriptionStatus(userResponse.data.is_subscribed);
//                     } else {
//                         setUserSubscriptionStatus(false); // Default to false on error/no data
//                     }
//                 } else {
//                     setUserSubscriptionStatus(false);
//                 }

//             } catch (err) {
//                 console.error("Error fetching cart or user data:", err);
//                 setError("Failed to load cart or subscription status. Please try again.");
//                 dispatch(setCart([]));
//                 dispatch(setCartId(null));
//                 dispatch(setTotalItems(0));
//                 dispatch(setTotalPrice(0));
//                 setTax(0);
//                 setUserSubscriptionStatus(false);
//             } finally {
//                 setIsLoading(false);
//             }
//         };

//         fetchCartAndSubscription();
//     }, [accessToken, apiEndpoint, dispatch, userId]);

//     const handleRemoveCartItem = async (cartItem) => {
//         if (!accessToken) {
//             setLoginPopupOpen(true);
//             return;
//         }

//         if (!cartItem?.id || removingFromCart) return;
//         setRemovingFromCart(true);
//         setError(null);

//         try {
//             const payload = {
//                 cart: [{
//                     product_id: cartItem.productId,
//                     quantity: 0
//                 }]
//             };

//             const response = await postWithTokenAPI(accessToken, '/cart/add', payload);

//             if (response?.statusCode === 200) {
//                 dispatch(removeFromCart(cartItem.id));
//                 toast.success('Item removed successfully!');
//                 setCartSuccessMessage('');

//                 const refreshResponse = await getWithTokenAPI(accessToken, apiEndpoint);
//                 const cartData = refreshResponse?.data?.Cart?.[0];
//                 if (refreshResponse?.statusCode === 200 && cartData) {
//                     dispatch(setTotalPrice(cartData.total_Price || 0));
//                     setTax(cartData.tax || 0);
//                     dispatch(setTotalItems(cartData.cart.length));
//                 }
//             } else {
//                 toast.error(response?.message || "Failed to remove item");
//             }
//         } catch (error) {
//             console.error("Error removing item:", error);
//             toast.error("Something went wrong. Please try again.");
//         } finally {
//             setRemovingFromCart(false);
//         }
//     };

//     const handleUpdateQuantity = async (id, newQuantity) => {
//         const item = cartItems.find(item => item.id === id);
//         if (!item || !accessToken || !cartId) return;

//         try {
//             const payload = {
//                 _id: cartId,
//                 cart: [{
//                     product_id: item.productId,
//                     quantity: newQuantity
//                 }]
//             };

//             const response = await putAPI(accessToken, '/cart/update', payload);

//             if (response?.statusCode === 200) {
//                 dispatch(updateQuantity({ id, quantity: newQuantity }));

//                 const refreshResponse = await getWithTokenAPI(accessToken, apiEndpoint);
//                 const cartData = refreshResponse?.data?.Cart?.[0];
//                 if (refreshResponse?.statusCode === 200 && cartData) {
//                     dispatch(setTotalPrice(cartData.total_Price || 0));
//                     setTax(cartData.tax || 0);
//                     dispatch(setTotalItems(cartData.cart.length));
//                 }
//             } else {
//                 console.error('Cart update failed:', response);
//                 toast.error(response?.message || 'Failed to update quantity.');
//             }
//         } catch (error) {
//             console.error('Error updating quantity:', error);
//             toast.error('Error updating quantity. Please try again.');
//         }
//     };

//     const increaseQuantity = (id) => {
//         const item = cartItems.find(item => item.id === id);
//         if (item) {
//             const newQuantity = item.quantity + 1;
//             handleUpdateQuantity(id, newQuantity);
//         }
//     };

//     const decreaseQuantity = (id) => {
//         const item = cartItems.find(item => item.id === id);
//         if (item && item.quantity > 1) {
//             const newQuantity = item.quantity - 1;
//             handleUpdateQuantity(id, newQuantity);
//         }
//     };

//     if (isLoading) {
//         return <div className="loading-indicator">Loading your cart...</div>;
//     }

//     // Original Handlechage function - this is where the subscription check will happen
//     const Handlechage = async () => {
//         if (!accessToken) {
//             setLoginPopupOpen(true);
//             return;
//         }

//         if (cartItems.length === 0) {
//             toast.error("Your cart is empty. Please add items before proceeding to checkout.");
//             return;
//         }

//         // Before navigating, check subscription status fetched in useEffect
//         if (!userSubscriptionStatus) { // If user is NOT subscribed
//             setShowSubscriptionPrompt(true); // Show the subscription prompt popup
//         } else {
//             // If user IS subscribed, proceed to checkout page
//             navigate('/checkout', {
//                 state: { is_subscribed: true } // Pass true because we confirmed they are subscribed
//             });
//         }
//     };

//     // Subscription Popup Handlers (Moved from BillingInfo)
//     const handleConfirmSubscriptionPrompt = () => {
//         setShowSubscriptionPrompt(false);
//         setShowSubscriptionDetails(true); // Show the subscription details/payment table
//     };

//     const handlePayForSubscription = async () => {
//         if (!userId || !userPhoneNumber) {
//             toast.error("User details (ID or Phone Number) are missing for subscription. Please log in again.");
//             return;
//         }
//         setSubscriptionLoading(true);
//         const payload = {
//             user_id: userId,
//             phoneNumber: userPhoneNumber
//         };

//         try {
//             const response = await postWithTokenAPI(accessToken, '/order/intiatesubcriptionpayment', payload);
//             if (response?.statusCode === 200 && response?.data) {
//                     console.log("payment initiate response",response)
//         const subscription_id = response?.data?.subscription_id
//         setSubsrcriptionId(subscription_id)
//         console.log('subscription_id',subscription_id)

//                 toast.success("Subscription payment initiated! Please complete the payment on your phone.");
//                   const start_date = response?.data?.createdAt;
//         const end_date = response?.data?.end_date;
//         const total_amount = 406;
//         //   setPaymentLoader(true);
//  const pollingInterval = setInterval(async () => {
//             try {
//               console.log('subscription_id',subscription_id)
//               const res = await getWithTokenAPI(accessToken,
//                 `/order/checkSubcriptionPaymentStatus?subscription_id=${subscription_id}`
//               );
//               console.log('status response',res)
//               const data = res.data;
//               if (data?.status === 'PAID') {
//                 clearInterval(pollingInterval);
//                 setPaymentSuccess(true);
//                 // navigation.navigate('successScreen')
//                     setUserSubscriptionStatus(true); // Mark as subscribed
//                     setShowSubscriptionDetails(false); // Close the details popup
//                     navigate('/checkout', { state: { is_subscribed: true } }); 
//               }
//             } catch (error) {
//               console.error('Error checking payment status:', error);
//             }
//           }, 5000);
 
//           setTimeout(() => {
//             clearInterval(pollingInterval);
//             setPaymentFailed(true);
//           }, 60000);
   
//           // Give user time to see toast and react to M-Pesa prompt
//             } else {
//                 toast.error('Subscription Payment Failed: ' + (response?.message || 'Unknown error'));
//             }
//         } catch (error) {
//             console.error('Error initiating subscription payment:', error);
//             toast.error('Failed to initiate subscription payment. Please check your network.');
//         } finally {
//             setSubscriptionLoading(false);
//         }
//     };


//     return (
//         <div className="shopping-cart-container">
//             {/* Login Popup */}
//             {isLoginPopupOpen && (
//                 <div className="login-popup-overlay">
//                     <div className="login-popup">
//                         <p>Please login to manage your cart</p>
//                         <button onClick={() => navigate('/login')}>Login</button>
//                         <button onClick={() => setLoginPopupOpen(false)}>Cancel</button>
//                     </div>
//                 </div>
//             )}

//             {/* --- Subscription Required Popup (moved from BillingInfo) --- */}
//             {showSubscriptionPrompt && (
             
//                  <div className="order-confirmation-overlay">
//                     <div className="order-confirmation-popup">
//                         <h3>Subscription Required </h3>
//                         <p>You need an active 1-month subscription to place an order. Please subscribe to continue</p>

//                         <div className="order-confirmation-buttons">
//                             <button
//                                 className="order-cancel-btn"
//                           onClick={() => setShowSubscriptionPrompt(false)}
//                             // disabled={orderProcessing}
//                             >
//                                 Cancel
//                             </button>
//                             <button
//                                 className="order-confirm-btn"
//                               onClick={handleConfirmSubscriptionPrompt}
//                             // disabled={orderProcessing}
//                             >
//                                 Subscribe Now
//                                 {/* {orderProcessing ? 'Processing...' : 'Subscribe Now'} */}
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* --- Subscription Details Popup (moved from BillingInfo) --- */}
//             {showSubscriptionDetails && (
              
//                     <div className="order-confirmation-overlay">
//                         <div className="order-confirmation-popup">
//                             <h3>Subscription Details </h3>
//                             <div>
//                                 <table>
//                                     <tr>
//                                         <th>Subscription Duration</th>
//                                         <th>1 Month</th>
//                                     </tr>
//                                     <tr>
//                                         <th>Subscripition Price</th>
//                                         <th>Ksh 350</th>
//                                     </tr>
//                                     <tr>
//                                         <th>
//                                             VAT(16%)
//                                         </th>
//                                         <th>Ksh56</th>
//                                     </tr>
//                                     <tr className='h6'>
//                                         <th>
//                                             Total Amount
//                                         </th>
//                                         <th>Ksh 406</th>
//                                     </tr>
//                                 </table>

//                             </div>
//                             <div className="order-confirmation-buttons">
//                                 <button
//                                     className="order-cancel-btn"
//                                onClick={() => setShowSubscriptionDetails(false)} disabled={subscriptionLoading}
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     className="order-confirm-btn"
//                                   onClick={handlePayForSubscription} disabled={subscriptionLoading}
//                                 >
//                                        {subscriptionLoading ? 'Processing...' : 'Pay Now'}
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//             )}

//             {/* Error/Success Messages */}
//             {error && <div className="error-message">{error}</div>}
//             {cartSuccessMessage && <div className="success-message">{cartSuccessMessage}</div>}

//             <div className="cart-content-wrapper">
//                 <div className="cart-main-content">
//                     <h1 className="cart-title ">My Shopping Cart</h1>

//                     {cartItems.length === 0 ? (
//                         <>
//                             <div className="empty-wishlist-container">
//                                 <div className="empty-wishlist-content">
//                                     <div className="empty-wishlist-illustration">
//                                         <div className='d-flex justify-content-center'>
//                                             <img src={cart} className='empty-wish-img' alt="Empty Cart" />
//                                         </div>

//                                         <div className="empty-wishlist-message">
//                                             <h3>Your Cart is currently empty</h3>
//                                             <p>Start exploring and save what you love!</p>
//                                         </div>
//                                     </div>
//                                     <button className="empty-wishlist-button" onClick={() => navigate('/shop')}>
//                                         Start Shopping
//                                     </button>
//                                 </div>
//                             </div>
//                         </>
//                     ) : (
//                         <>
//                             <div className="cart-table-wrapper compact-cart-table">
//                                 <table className="cart-table">
//                                     <thead>
//                                         <tr>
//                                             <th>PRODUCT</th>
//                                             <th>PRICE</th>
//                                             <th>QUANTITY</th>
//                                             <th>SUBTOTAL</th>
//                                             <th>ACTION</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {cartItems.map(item => (
//                                             <tr key={item.id}>
//                                                 <td className="product-cell">
//                                                     <img src={item.image} alt={item.name} className="product-img" />
//                                                     <span className="product-name">{item.name}</span>
//                                                 </td>
//                                                 <td>KSh {item.price.toFixed(2)}</td>
//                                                 <td>
//                                                     <div className="quantity-selector">
//                                                         <button
//                                                             onClick={() => decreaseQuantity(item.id)}
//                                                             className="quantity-btn"
//                                                             disabled={removingFromCart}
//                                                         >
//                                                             –
//                                                         </button>
//                                                         <span>{item.quantity}</span>
//                                                         <button
//                                                             onClick={() => increaseQuantity(item.id)}
//                                                             className="quantity-btn"
//                                                             disabled={removingFromCart}
//                                                         >
//                                                             +
//                                                         </button>
//                                                     </div>
//                                                 </td>
//                                                 <td>KSh {(item.price * item.quantity).toFixed(2)}</td>
//                                                 <td>
//                                                     <button
//                                                         onClick={() => handleRemoveCartItem(item)}
//                                                         className="remove-btn"
//                                                         disabled={removingFromCart}
//                                                     >
//                                                         {removingFromCart ? '...' : '×'}
//                                                     </button>
//                                                 </td>
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>

//                                 <div className="compact-cart-actions">
//                                     <button className="return-btn" onClick={() => navigate('/shop')}>Return to Shop</button>
//                                 </div>
//                             </div>
//                         </>
//                     )}
//                 </div>

//                 {/* Cart totals section */}
//                 {cartItems.length > 0 && (
//                     <div className="compact-cart-totals">
//                         <h2 className="totals-title">Cart Total</h2>
//                         <div className="totals-rows">
//                             <span>Subtotal:</span>
//                             <span>KSh {totalPrice.toFixed(2)}</span>
//                         </div>
//                         <div className="totals-row">
//                             <span>VAT(16%) :</span>
//                             <span>KSh {tax.toFixed(2)}</span> {/* Ensure tax is formatted */}
//                         </div>
//                         <div className="totals-row total">
//                             <span>Total:</span>
//                             <span className="total-price">KSh {(totalPrice + (tax || 0)).toFixed(2)}</span>
//                         </div>
//                         <button
//                             className="checkout-btn-for"
//                             onClick={Handlechage} 
//                             disabled={removingFromCart || cartItems.length === 0}
//                         >
//                             Proceed to Checkout
//                         </button>
//                     </div>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default ShoppingCart;


import React, { useEffect, useState } from 'react';
import '../../style/shop.css';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import cart from '../../assets/carttt.png'
import { removeFromCart, updateQuantity, setCart, setCartId, setTotalPrice } from '../../store/cartSlice';
import { getWithTokenAPI, postWithTokenAPI, putAPI } from '../../util/Api';
import { setTotalItems } from '../../store/cartSlice';
import { toast } from 'react-toastify'; // Import toast for notifications

const ShoppingCart = ({ apiEndpoint = '/cart/find-all' }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const accessToken = useSelector((state) => state.auth?.auth?.access_token);
    const userId = useSelector(state => state.auth?.auth?._id);
    const userPhoneNumber = useSelector(state => state.auth?.auth?.phone_number); // Get phone number for M-Pesa
    const cartItems = useSelector((state) => state.cart.cartItems);
    const totalPrice = useSelector((state) => state.cart.totalPrice);
    const [couponCode, setCouponCode] = useState('');
    const [cartSuccessMessage, setCartSuccessMessage] = useState('');
    const [removingFromCart, setRemovingFromCart] = useState(false);
    const [error, setError] = useState(null);
    const [isLoginPopupOpen, setLoginPopupOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const totals = useSelector((state) => state.cart.totalItems);
    const cartId = useSelector((state) => state.cart.cartId);
    const [tax, setTax] = useState(0);

    const [showSubscriptionPrompt, setShowSubscriptionPrompt] = useState(false);
    const [showSubscriptionDetails, setShowSubscriptionDetails] = useState(false);
    const [subscriptionLoading, setSubscriptionLoading] = useState(false);
    const [userSubscriptionStatus, setUserSubscriptionStatus] = useState(false);
    const [subscriptionID, setSubsrcriptionId] = useState(false);
    const [paymentLoader, setPaymentLoader] = useState(false);
    const [paymentSuccess, setPaymentSuccess] = useState(false);
    const [paymentFailed, setPaymentFailed] = useState(false);
    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        const fetchCartAndSubscription = async () => {
            if (!accessToken) {
                setIsLoading(false);
                return;
            }

            try {
                setIsLoading(true);

                const cartResponse = await getWithTokenAPI(accessToken, apiEndpoint);
                const cartData = cartResponse?.data?.Cart?.[0];

                if (cartResponse?.statusCode === 200 && cartData) {
                    setTax(cartData.tax || 0);
                    if (cartData?.cart?.length) {
                        const formattedCartItems = cartData.cart.map(item => ({
                            id: item._id,
                            productId: item.product_id._id,
                            image: item.product_id.product_image?.[0] || "",
                            name: item.product_id.name || "",
                            price: parseFloat(item.product_id.discount_price || item.product_id.price || 0),
                            quantity: item.quantity || 1
                        }));
                        dispatch(setCart(formattedCartItems));
                        dispatch(setCartId(cartData._id));
                        dispatch(setTotalItems(cartData.cart.length));
                        dispatch(setTotalPrice(cartData.total_Price || 0));
                    } else {
                        dispatch(setCart([]));
                        dispatch(setCartId(null));
                        dispatch(setTotalItems(0));
                        dispatch(setTotalPrice(0));
                    }
                } else {
                    dispatch(setCart([]));
                    dispatch(setCartId(null));
                    dispatch(setTotalItems(0));
                    dispatch(setTotalPrice(0));
                    setTax(0);
                }

                if (userId) {
                    const userResponse = await getWithTokenAPI(accessToken, `/user/find-particular?_id=${userId}`);
                    if (userResponse.statusCode === 200 && userResponse.data) {
                        setUserSubscriptionStatus(userResponse.data.is_subscribed);
                    } else {
                        setUserSubscriptionStatus(false);
                    }
                } else {
                    setUserSubscriptionStatus(false);
                }

            } catch (err) {
                console.error("Error fetching cart or user data:", err);
                setError("Failed to load cart or subscription status. Please try again.");
                dispatch(setCart([]));
                dispatch(setCartId(null));
                dispatch(setTotalItems(0));
                dispatch(setTotalPrice(0));
                setTax(0);
                setUserSubscriptionStatus(false);
            } finally {
                setIsLoading(false);
            }
        };

        fetchCartAndSubscription();
    }, [accessToken, apiEndpoint, dispatch, userId]);

    const handleRemoveCartItem = async (cartItem) => {
        if (!accessToken) {
            setLoginPopupOpen(true);
            return;
        }

        if (!cartItem?.id || removingFromCart) return;
        setRemovingFromCart(true);
        setError(null);

        try {
            const payload = {
                cart: [{
                    product_id: cartItem.productId,
                    quantity: 0
                }]
            };

            const response = await postWithTokenAPI(accessToken, '/cart/add', payload);

            if (response?.statusCode === 200) {
                dispatch(removeFromCart(cartItem.id));
                toast.success('Item removed successfully!');
                setCartSuccessMessage('');

                const refreshResponse = await getWithTokenAPI(accessToken, apiEndpoint);
                const cartData = refreshResponse?.data?.Cart?.[0];
                if (refreshResponse?.statusCode === 200 && cartData) {
                    dispatch(setTotalPrice(cartData.total_Price || 0));
                    setTax(cartData.tax || 0);
                    dispatch(setTotalItems(cartData.cart.length));
                }
            } else {
                toast.error(response?.message || "Failed to remove item");
            }
        } catch (error) {
            console.error("Error removing item:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setRemovingFromCart(false);
        }
    };

    const handleUpdateQuantity = async (id, newQuantity) => {
        const item = cartItems.find(item => item.id === id);
        if (!item || !accessToken || !cartId) return;

        try {
            const payload = {
                _id: cartId,
                cart: [{
                    product_id: item.productId,
                    quantity: newQuantity
                }]
            };

            const response = await putAPI(accessToken, '/cart/update', payload);

            if (response?.statusCode === 200) {
                dispatch(updateQuantity({ id, quantity: newQuantity }));

                const refreshResponse = await getWithTokenAPI(accessToken, apiEndpoint);
                const cartData = refreshResponse?.data?.Cart?.[0];
                if (refreshResponse?.statusCode === 200 && cartData) {
                    dispatch(setTotalPrice(cartData.total_Price || 0));
                    setTax(cartData.tax || 0);
                    dispatch(setTotalItems(cartData.cart.length));
                }
            } else {
                console.error('Cart update failed:', response);
                toast.error(response?.message || 'Failed to update quantity.');
            }
        } catch (error) {
            console.error('Error updating quantity:', error);
            toast.error('Error updating quantity. Please try again.');
        }
    };

    const increaseQuantity = (id) => {
        const item = cartItems.find(item => item.id === id);
        if (item) {
            const newQuantity = item.quantity + 1;
            handleUpdateQuantity(id, newQuantity);
        }
    };

    const decreaseQuantity = (id) => {
        const item = cartItems.find(item => item.id === id);
        if (item && item.quantity > 1) {
            const newQuantity = item.quantity - 1;
            handleUpdateQuantity(id, newQuantity);
        }
    };

    if (isLoading) {
        return <div className="loading-indicator">Loading your cart...</div>;
    }

    const Handlechage = async () => {
        if (!accessToken) {
            setLoginPopupOpen(true);
            return;
        }

        if (cartItems.length === 0) {
            toast.error("Your cart is empty. Please add items before proceeding to checkout.");
            return;
        }

        // if (!userSubscriptionStatus) {
        //     setShowSubscriptionPrompt(true);
        // } else {
        //     navigate('/checkout', {
        //         state: { is_subscribed: true }
        //     });
        // }

         navigate('/checkout', {
                state: { is_subscribed: true }
            });

    };

    const handleConfirmSubscriptionPrompt = () => {
        setShowSubscriptionPrompt(false);
        setShowSubscriptionDetails(true);
    };

    const handlePayForSubscription = async () => {
        if (!userId || !userPhoneNumber) {
            toast.error("User details (ID or Phone Number) are missing for subscription. Please log in again.");
            return;
        }

        setSubscriptionLoading(true);
        setShowLoader(true);

        const payload = {
            user_id: userId,
            phoneNumber: userPhoneNumber
        };

        let pollingInterval;

        try {
            const response = await postWithTokenAPI(accessToken, '/order/intiatesubcriptionpayment', payload);

            if (response?.statusCode === 200 && response?.data) {
                // console.log("payment initiate response", response);
                const subscription_id = response?.data?.subscription_id;
                setSubsrcriptionId(subscription_id);
                // console.log('subscription_id', subscription_id);

                toast.info("Subscription payment initiated! Please complete the payment on your phone.");

                let attempts = 0;
                const maxAttempts = 6; // 6 attempts
                const pollingDelay = 15000; // 15 seconds in milliseconds

                pollingInterval = setInterval(async () => {
                    attempts++;
                    if (attempts > maxAttempts) {
                        clearInterval(pollingInterval);
                        if (!paymentSuccess && !paymentFailed) {
                            toast.warn("Payment status check timed out. Please check your payment history or try again.");
                            setShowLoader(false);
                            setPaymentFailed(true);
                        }
                        return;
                    }

                    try {
                        // console.log(`Checking subscription status for ID: ${subscription_id} (Attempt ${attempts}/${maxAttempts})`);
                        const res = await getWithTokenAPI(accessToken,
                            `/order/checkSubcriptionPaymentStatus?subscription_id=${subscription_id}`
                        );
                        // console.log('Status response:', res);

                        // Primary check for M-Pesa status
                        if (res?.statusCode === 200 && res?.data?.mpesa_status) {
                            const mpesaResponseCode = res.data.mpesa_status.ResponseCode;

                            if (mpesaResponseCode === '0') { // M-Pesa successful
                                clearInterval(pollingInterval);
                                setPaymentSuccess(true);
                                setShowLoader(false);
                                toast.success("Subscription payment successful! Proceeding to checkout.");
                                setUserSubscriptionStatus(true);
                                setShowSubscriptionDetails(false);
                                navigate('/checkout', { state: { is_subscribed: true } });
                            } else { // M-Pesa failed or not '0'
                                // If the ResponseCode is not '0', it indicates a failure from M-Pesa's side.
                                // We should stop polling and inform the user of the failure.
                                clearInterval(pollingInterval);
                                setPaymentFailed(true);
                                setShowLoader(false);
                                toast.error("Subscription payment failed. Please try again or check your M-Pesa.");
                            }
                        }
                        // Removed the `else if (res?.statusCode === 200 && res?.data?.status)` block entirely,
                        // as per your clarification that the 'status' key won't be present.
                        else {
                            // This block handles cases where statusCode is not 200 or mpesa_status is missing/invalid.
                            // We continue polling for these cases until max attempts are reached,
                            // assuming it might be a temporary issue or pending state where mpesa_status isn't fully ready.
                            console.warn("Unexpected status response during polling or mpesa_status not yet available:", res);
                        }

                    } catch (error) {
                        console.error('Error checking payment status:', error);
                        // If there's an actual network error or unhandled exception during polling
                        clearInterval(pollingInterval); // Stop polling on unhandled errors
                        setPaymentFailed(true);
                        setShowLoader(false);
                        toast.error("An error occurred while checking payment status. Please try again.");
                    }
                }, pollingDelay); // Use the new pollingDelay (15 seconds)

            } else {
                setShowLoader(false);
                toast.error('Subscription Payment Failed: ' + (response?.message || 'Unknown error'));
            }
        } catch (error) {
            console.error('Error initiating subscription payment:', error);
            setShowLoader(false);
            toast.error('Failed to initiate subscription payment. Please check your network.');
            if (pollingInterval) clearInterval(pollingInterval);
        } finally {
            setSubscriptionLoading(false);
        }
    };


    return (
        <div className="shopping-cart-container">
            {/* Login Popup */}
            {isLoginPopupOpen && (
                <div className="login-popup-overlay">
                    <div className="login-popup">
                        <p>Please login to manage your cart</p>
                        <button onClick={() => navigate('/login')}>Login</button>
                        <button onClick={() => setLoginPopupOpen(false)}>Cancel</button>
                    </div>
                </div>
            )}

            {/* --- Subscription Required Popup (moved from BillingInfo) --- */}
            {showSubscriptionPrompt && (

                <div className="order-confirmation-overlay">
                    <div className="order-confirmation-popup">
                        <h3>Subscription Required </h3>
                        <p>You need an active 1-month subscription to place an order. Please subscribe to continue</p>

                        <div className="order-confirmation-buttons">
                            <button
                                className="order-cancel-btn"
                                onClick={() => setShowSubscriptionPrompt(false)}
                            >
                                Cancel
                            </button>
                            <button
                                className="order-confirm-btn"
                                onClick={handleConfirmSubscriptionPrompt}
                            >
                                Subscribe Now
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* --- Subscription Details Popup (moved from BillingInfo) --- */}
            {showSubscriptionDetails && (

                <div className="order-confirmation-overlay">
                    <div className="order-confirmation-popup">
                        <h3>Subscription Details </h3>
                        <div>
                            <table>
                                <tr>
                                    <th>Subscription Duration</th>
                                    <th>1 Month</th>
                                </tr>
                                <tr>
                                    <th>Subscripition Price</th>
                                    <th>Ksh 350</th>
                                </tr>
                                <tr>
                                    <th>
                                        VAT(16%)
                                    </th>
                                    <th>Ksh56</th>
                                </tr>
                                <tr className='h6'>
                                    <th>
                                        Total Amount
                                    </th>
                                    <th>Ksh 406</th>
                                </tr>
                            </table>

                        </div>
                        <div className="order-confirmation-buttons">
                            <button
                                className="order-cancel-btn"
                                onClick={() => setShowSubscriptionDetails(false)} disabled={subscriptionLoading || showLoader}
                            >
                                Cancel
                            </button>
                            <button
                                className="order-confirm-btn"
                                onClick={handlePayForSubscription}
                                disabled={subscriptionLoading || showLoader}
                            >
                                {showLoader ? 'Processing Payment...' : 'Pay Now'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {/* Loader for payment processing */}
            {showLoader && (
                <div className="loader-overlay">
                    <div className="loader"></div>
                    <p>Processing your subscription payment, please wait...</p>
                </div>
            )}

            {/* Error/Success Messages */}
            {error && <div className="error-message">{error}</div>}
            {cartSuccessMessage && <div className="success-message">{cartSuccessMessage}</div>}

            <div className="cart-content-wrapper">
                <div className="cart-main-content">
                    <h1 className="cart-title ">My Shopping Cart</h1>

                    {cartItems.length === 0 ? (
                        <>
                            <div className="empty-wishlist-container">
                                <div className="empty-wishlist-content">
                                    <div className="empty-wishlist-illustration">
                                        <div className='d-flex justify-content-center'>
                                            <img src={cart} className='empty-wish-img' alt="Empty Cart" />
                                        </div>

                                        <div className="empty-wishlist-message">
                                            <h3>Your Cart is currently empty</h3>
                                            <p>Start exploring and save what you love!</p>
                                        </div>
                                    </div>
                                    <button className="empty-wishlist-button" onClick={() => navigate('/shop')}>
                                        Start Shopping
                                    </button>
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="cart-table-wrapper compact-cart-table">
                                <table className="cart-table">
                                    <thead>
                                        <tr>
                                            <th>PRODUCT</th>
                                            <th>PRICE</th>
                                            <th>QUANTITY</th>
                                            <th>SUBTOTAL</th>
                                            <th>ACTION</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {cartItems.map(item => (
                                            <tr key={item.id}>
                                                <td className="product-cell">
                                                    <img src={item.image} alt={item.name} className="product-img" />
                                                    <span className="product-name">{item.name}</span>
                                                </td>
                                                <td>KSh {item.price.toFixed(2)}</td>
                                                <td>
                                                    <div className="quantity-selector">
                                                        <button
                                                            onClick={() => decreaseQuantity(item.id)}
                                                            className="quantity-btn"
                                                            disabled={removingFromCart}
                                                        >
                                                            –
                                                        </button>
                                                        <span>{item.quantity}</span>
                                                        <button
                                                            onClick={() => increaseQuantity(item.id)}
                                                            className="quantity-btn"
                                                            disabled={removingFromCart}
                                                        >
                                                            +
                                                        </button>
                                                    </div>
                                                </td>
                                                <td>KSh {(item.price * item.quantity).toFixed(2)}</td>
                                                <td>
                                                    <button
                                                        onClick={() => handleRemoveCartItem(item)}
                                                        className="remove-btn"
                                                        disabled={removingFromCart}
                                                    >
                                                        {removingFromCart ? '...' : '×'}
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                <div className="compact-cart-actions">
                                    <button className="return-btn" onClick={() => navigate('/shop')}>Return to Shop</button>
                                </div>
                            </div>
                        </>
                    )}
                </div>

                {/* Cart totals section */}
                {cartItems.length > 0 && (
                    <div className="compact-cart-totals">
                        <h2 className="totals-title">Cart Total</h2>
                        <div className="totals-rows">
                            <span>Subtotal:</span>
                            <span>KSh {totalPrice.toFixed(2)}</span>
                        </div>
                        <div className="totals-row">
                            <span>VAT(16%) :</span>
                            <span>KSh {tax.toFixed(2)}</span>
                        </div>
                        <div className="totals-row total">
                            <span>Total:</span>
                            <span className="total-price">KSh {(totalPrice + (tax || 0)).toFixed(2)}</span>
                        </div>
                        <button
                            className="checkout-btn-for"
                            onClick={Handlechage}
                            disabled={removingFromCart || cartItems.length === 0}
                        >
                            Proceed to Checkout
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ShoppingCart;